"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var _default = function _default(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    height: "24",
    viewBox: "0 0 47.3 24",
    width: "47.3",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/_react["default"].createElement("path", {
    d: "m21.1 4h-2.35a.76.76 0 0 0 -.7.43l-1.95 3.92a.8.8 0 0 0 .35 1.05.85.85 0 0 0 .35.08.78.78 0 0 0 .7-.43l1.73-3.48h1.87a.78.78 0 1 0 0-1.57z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "m46.52 18.44h-.52v-6.44a4 4 0 0 0 -4-4h-2.39l-3.72-7.45a1 1 0 0 0 -.89-.55h-19a1 1 0 0 0 -.9.55l-3.72 7.45h-7.38a4 4 0 0 0 -4 4v7a1 1 0 0 0 1 1h4a.8.8 0 0 0 .15 0s0 .08 0 .12a3.92 3.92 0 0 0 7.83 0s0-.07 0-.1h20.02a.8.8 0 0 0 .15 0s0 .08 0 .12a3.92 3.92 0 0 0 7.83 0s.02-.14.02-.14h5.57a.78.78 0 0 0 0-1.56zm-35.12 1.65a2.36 2.36 0 1 1 -2.35-2.36 2.35 2.35 0 0 1 2.35 2.36zm28 0a2.36 2.36 0 1 1 -2.35-2.36 2.35 2.35 0 0 1 2.35 2.36zm-2.35-3.91a3.91 3.91 0 0 0 -3.55 2.28 3.84 3.84 0 0 0 -.5 0h-20.42a3.9 3.9 0 0 0 -7.08 0 3.84 3.84 0 0 0 -.5 0h-3.44v-6.46c0-1.1.9-2.43 2-2.43h8.18a1 1 0 0 0 .9-.56l3.68-7.43h18.34l3.71 7.42a1 1 0 0 0 .9.55h3.15c1.1 0 2 1.34 2 2.44v6.44h-3.59a.93.93 0 0 0 -.23 0 3.9 3.9 0 0 0 -3.55-2.25z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "m23.43 4.53h10.96v10.96h-10.96z"
  }));
};

exports["default"] = _default;